
export const common = {
  'call.us': 'Llámenos',
  'privacy.policy': 'Política de privacidad',
  'select.location': 'Seleccione su ubicación',
  'location.description': 'Elija su ubicación para llamar al número apropiado',
  'usa': 'EE.UU.',
  'non.usa': 'Fuera de EE.UU. Llamada o WhatsApp',
  'documents.downloads': 'Documentos y descargas',
  'item': 'Ítem',
  'value': 'Valor',
  'price': 'Precio',
  'product': 'Producto',
  'msrp': 'MSRP',
};
